export enum VehicleRole {
    NOT_SPECIFIED = 'NOT_SPECIFIED',
    PRIMARY = 'PRIMARY',
    REPLACEMENT = 'REPLACEMENT',
    SUPPLEMENTARY = 'SUPPLEMENTARY',
    RESERVE = 'RESERVE'
}
